module.exports = __webpack_public_path__ + "img/inviteandroid.0f50c17d.png";